import Vue from 'vue/dist/vue.esm';
import template from './district_teachers_with_feedback_report_template.slim';
import { getWidth } from '../commonChartFunctions';
import chartFilterable from '../../mixins/chart_filterable';

Vue.component('district_teachers_with_feedback_report', {
  mixins: [template, chartFilterable],
  props: ['school_year_label', 'year_info', 'report_date', 'section', 'templates'],
  data() {
    return {
      startDate: '',
      endDate: '',
      chartData: {},
      chartOptions: {
        chart: {
          type: 'bar',
          height: 350,
        },
        xaxis: {
          categories: [],
          labels: {
            trim: true,
            rotate: -55,
            style: {
              fontSize: '10px'
            }
          }
        },
        yaxis: {
          title: {
            text: '% of Staff with Feedback Sessions'
          },
          max: 100,
          forceNiceScale: false
        },
        legend: {
          position: 'bottom'
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return `${val}%`;
            }
          }
        },
        dataLabels: {
          enabled: false
        }
      },
      series: []
    };
  },
  mounted() {
    this.updateChart();
  },
  computed: {
    chartWidth() {
      return getWidth(this.series[0]?.data.length || 0);
    },
  },
  methods: {
    updateChart() {
      if (!this.chartData || Object.keys(this.chartData).length === 0) {
        return;
      }

      const sortedData = Object.entries(this.chartData)
        .map(([school, percentage]) => {
          return { school, percentage: percentage || 0 };
        })
        .sort((a, b) => b.percentage - a.percentage);

      const sortedSchoolNames = sortedData.map(data => data.school);
      const sortedFeedbackPercentages = sortedData.map(data => data.percentage);

      this.chartOptions.xaxis.categories = sortedSchoolNames;

      this.series = [{
        name: 'Teachers with Feedback',
        data: sortedFeedbackPercentages
      }];

      this.$refs.apexChart?.updateOptions(this.chartOptions);
    },
    applyData(data) {
      this.chartData = data;
      this.updateChart();
    }
  }
});
